import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toggleDeleteModal, deleteDictionary } from '../../../../actions/dictionary-values';
import { Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { ModalComponent } from '../../../../components/Modal/modal';
import { Button } from '../../../../components/button/button';
import { Checkbox } from '../../../../components/checkbox/checkbox';
import theme from '../../../../theme';
export const DeleteModal = ()=>{
    const dispatch = useDispatch();
    const { associatedDictionaries } = useSelector((state)=>state.dictionary);
    let defaults = {};
    associatedDictionaries.forEach((dictionary)=>{
        defaults[dictionary.id] = false;
    });
    const [deleteSelection, changeDeleteSelection] = useState(defaults);
    const _handleDelete = (deleteIds)=>{
        dispatch(deleteDictionary(deleteIds));
    };
    const _handleSubmit = ()=>{
        const deleteIds = Object.keys(deleteSelection).filter((id)=>deleteSelection[id]);
        _handleDelete(deleteIds);
    };
    const _handleClose = ()=>{
        dispatch(toggleDeleteModal(false));
    };
    const dictionariesForm = associatedDictionaries.map((dictionary)=>{
        return {
            key: dictionary.id.toString(),
            helpText: dictionary.status
        };
    });
    const name = associatedDictionaries[0]?.name ?? '';
    const handleServiceLineSelection = (event)=>{
        const values = {
            ...deleteSelection
        };
        values[event.target.id] = event.target.checked;
        changeDeleteSelection(values);
    };
    return associatedDictionaries.length > 1 ? /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx(Text, {
            children: "Multiple Dictionaries Found"
        }),
        modalContent: /*#__PURE__*/ _jsxs(Grid, {
            sx: {
                margin: `0 ${theme.space[16]}`
            },
            children: [
                name,
                " exists in multiple states. Which would you like to delete?",
                /*#__PURE__*/ _jsx(GridItem, {
                    sx: {
                        margin: `0 0 0 ${theme.space[16]}`
                    },
                    children: dictionariesForm.map((item)=>{
                        return /*#__PURE__*/ _jsx(Checkbox, {
                            label: item.helpText,
                            onChange: handleServiceLineSelection,
                            id: item.key,
                            isChecked: deleteSelection[`${item.key}`],
                            dataTestId: item.helpText,
                            name: item.helpText
                        }, item.key);
                    })
                })
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsxs(Flex, {
            columnGap: '8px',
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Cancel',
                    onClick: _handleClose,
                    name: 'Cancel',
                    dataTestId: 'Cancel'
                }),
                ' ',
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Delete Selection',
                    onClick: _handleSubmit,
                    disabled: !Object.values(deleteSelection).includes(true),
                    dataTestId: 'deleteBtn',
                    name: 'Delete'
                })
            ]
        })
    }) : /*#__PURE__*/ _jsx(ModalComponent, {
        size: 'xl',
        isOpen: true,
        handleClose: _handleClose,
        modalHeader: /*#__PURE__*/ _jsx(Text, {
            children: "Are you sure?"
        }),
        modalContent: /*#__PURE__*/ _jsxs(Text, {
            sx: {
                margin: `0 ${theme.space[16]}`
            },
            children: [
                "Delete ",
                name,
                "?"
            ]
        }),
        modalFooter: /*#__PURE__*/ _jsxs(Flex, {
            columnGap: '8px',
            children: [
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Cancel',
                    onClick: _handleClose,
                    name: 'Cancel',
                    dataTestId: 'Cancel'
                }),
                ' ',
                /*#__PURE__*/ _jsx(Button, {
                    label: 'Delete',
                    dataTestId: 'deleteBtn',
                    name: 'Delete',
                    onClick: ()=>_handleDelete([
                            associatedDictionaries[0].id.toString()
                        ])
                })
            ]
        })
    });
};
